import { generatePowerOfAttorneyPDF } from './powerOfAttorneyGenerator';
import { pdfToPageImages } from './pdfPageImages';
import { loadPdfJs } from "./pdfEngines";


async function convertPdfToImage(pdfBytes) {
  const loadingTask = (await loadPdfJs()).getDocument({ data: pdfBytes });
  const pdf = await loadingTask.promise;

  const page = await pdf.getPage(1);
  const scale = 2;
  const viewport = page.getViewport({ scale });

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  return canvas.toDataURL('image/png', 0.9);
}

export const generatePowerOfAttorneyPreview = async (formData) => {
  try {
    const pdfBytes = await generatePowerOfAttorneyPDF(formData, true);
    return await convertPdfToImage(pdfBytes);
  } catch (error) {
    console.error("Error generating Power of Attorney preview:", error);
    throw error;
  }
};

// All pages, for the in-app preview modal's page slider
export const generatePowerOfAttorneyPreviewPages = async (formData) => {
  try {
    const pdfBytes = await generatePowerOfAttorneyPDF(formData, true);
    return await pdfToPageImages(pdfBytes);
  } catch (error) {
    console.error("Error generating Power of Attorney preview pages:", error);
    throw error;
  }
};
